module.exports = __webpack_public_path__ + "static/media/alarm.fabd83bc.svg";